<template>
  <el-dialog custom-class="collect-corporate-result-container dialog-size-large"
             title="データ収集結果"
             :visible="true"
             :append-to-body="true"
             top="0"
             :modal="false"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="collect-corporate-result-container-inner">
      <fixed-header-table :fixed="collectResult.data != null && collectResult.data.length > 0"
                          class="collect-corporate-result-overview">
        <tr slot="header">
          <td></td>
          <th v-for="column in displayColumns">{{column.label}}</th>
        </tr>
        <tr v-for="row in collectResult.data">
          <td>
            <el-button type="info" @click="onClickGetDetail(row)">詳細を取得</el-button>
          </td>
          <td v-for="column in displayColumns">{{formatNumberCell(row, column)}}</td>
        </tr>
      </fixed-header-table>
      <h3 v-if="collectResult.data != null && collectResult.data.length === 0">対象のデータが見つかりませんでした</h3>
    </div>

    <collect-corporation-result-detail-dialog
            v-if="visibleDetailResult"
            :visible="visibleDetailResult"
            :corp-code="selectedCorporationSummary.corpCode"
            :corp-detail="getCorpDetailByCode(selectedCorporationSummary.corpCode).detail"
            @close="visibleDetailResult=false">
    </collect-corporation-result-detail-dialog>
  </el-dialog>
</template>

<script lang="js">
import FormatUtil from '../../../utils/format'
import CollectCorporationDetailResultDialogCmp from './collect-corporation-detail-result.vue'
import WebApiClient, { GetDataCollectionCorporationsResult } from '../../../api/web'
import CommonUtil from '../../../utils/common'

export default {
  name: 'CollectResultDialogCmp',
  components: {
    'collect-corporation-result-detail-dialog': CollectCorporationDetailResultDialogCmp
  },
  props: {
    collectResult: GetDataCollectionCorporationsResult
  },
  computed: {
    ignoreFormatNumberColumns () {
      return ['corp_code']
    },
    displayColumns () {
      return [
        { 'value': 'corpCode', 'label': '法人番号' },
        { 'value': 'corpName', 'label': '名称' },
        { 'value': 'corpType', 'label': '法人種別' },
        { 'value': 'location', 'label': '国内所在地' },
        { 'value': 'postalCode', 'label': '郵便番号' },
        { 'value': 'updatedAt', 'label': '更新年月日' }
      ]
    }
  },
  data () {
    return {
      visibleDetailResult: false,
      selectedCorporationSummary: null,
      corpDetails: []
    }
  },
  methods: {
    formatNumberCell (corporation, column) {
      let result = null

      const value = column.value
      if (value === 'location') {
        return corporation.pref + corporation.city + corporation.street
      }

      for (let key of Object.keys(corporation)) {
        if (value === key) {
          if (this.ignoreFormatNumberColumns.indexOf(value) !== -1) {
            result = FormatUtil.formatNumber(corporation[key], '-')
            break
          } else {
            result = corporation[key]
            break
          }
        }
      }
      return result || '-'
    },

    onClickGetDetail (corporation) {
      this.selectedCorporationSummary = corporation
      this.loadCorpDetail(corporation.corpCode).then(() => {
        this.visibleDetailResult = true
      })
    },

    getCorpDetailByCode (corpCode) {
      return this.corpDetails.filter(detail => detail.corpCode === corpCode)[0]
    },

    loadCorpDetail (corpCode) {
      const corpSummary = this.selectedCorporationSummary
      let targetDetail = this.getCorpDetailByCode(corpCode)

      if (CommonUtil.isNotEmpty(targetDetail)) {
        return Promise.resolve()
      }

      const param = {
        filters: {
          corpName: corpSummary.corpName,
          corpType: corpSummary.corpType,
          pref: corpSummary.pref,
          city: corpSummary.city,
          street: corpSummary.street,
          postalCode: corpSummary.postalCode
        }
      }

      return WebApiClient.getDataCollectionCorporation(this, corpCode, param).then(response => {
        const detail = response.data.result
        this.corpDetails.push({
          corpCode: corpCode,
          detail: detail
        })
      })
    }
  }
}

</script>

<style scoped>
  .collect-corporate-result-container-inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .collect-corporate-result-overview {
    max-height: 480px;
  }

</style>



// WEBPACK FOOTER //
// src/components/data-collect/dialogs/collect-corporation-result.vue